import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-6 md:pb-18 2xl:py-14 2xl:px-40 relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BannerView = _resolveComponent("BannerView")!
  const _component_CoursesView = _resolveComponent("CoursesView")!
  const _component_JourneyView = _resolveComponent("JourneyView")!
  const _component_FooterView = _resolveComponent("FooterView")!
  const _component_ToastSocialSharing = _resolveComponent("ToastSocialSharing")!
  const _component_ch_toast = _resolveComponent("ch-toast")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BannerView),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CoursesView),
          _createVNode(_component_JourneyView),
          _createVNode(_component_FooterView),
          _createVNode(_component_ToastSocialSharing),
          (_ctx.toast.toggle)
            ? (_openBlock(), _createBlock(_component_ch_toast, {
                key: 0,
                opened: _ctx.toast.toggle,
                position: "right_top",
                label: _ctx.toast.label,
                type: _ctx.toast.type,
                onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toast.toggle = false)),
                class: "!z-[100]"
              }, null, 8, ["opened", "label", "type"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}